<template>
    <div class="evaluation-page">
        <div class="timer-frame" v-if="remainingTime">
            <p>Temps restant :</p>
            <p>{{ remainingTime.minutes }}m {{ remainingTime.seconds }}s</p>
        </div>

        <h1>{{ quizData?.name }}</h1>

        <div class="message-frame" v-if="quizData && !quizData?.beginingDate">
            <h2>Prêt à commencer ?</h2>
            <p>Le quiz va commencer. Pour chaque question, le barème de point sera le suivant :</p>
            <ul class="points-list">
                <li>Bonne réponse et niveau de confiance élevé : {{ quizData?.notation?.nbPointHigh }} point.</li>
                <li>Bonne réponse et niveau de confiance moyen : {{ quizData?.notation?.nbPointMedium }} point.</li>
                <li>Bonne réponse et niveau de confiance bas : {{ quizData?.notation?.nbPointLow }} point.</li>
            </ul>

            <ul class="malus-list">
                <li>Mauvaise réponse et niveau de confiance élevé : - {{ quizData?.notation?.malusHigh }} point.</li>
                <li>Mauvaise réponse et niveau de confiance moyen : - {{ quizData?.notation?.malusMedium }} point.</li>
                <li>Mauvaise réponse et niveau de confiance bas : - {{ quizData?.notation?.malusLow }} point.</li>
            </ul>

            <p><b>Attention :</b> Si vous changez d'onglet ou de fenetre 3 fois, le quiz prendra fin automatiquement.</p>

            <p>Une fois le quiz commencé, vous ne pourrez plus l'arrêter ou recommencer. Vous aurez {{
                quizData?.nbMinutesDuration }} minutes pour répondre.</p>

            <div class="btn-wrapper">
                <div @click="startQuiz">Commencer</div>
            </div>
        </div>

        <div class="message-frame" v-else-if="quizData && quizData.status == 'finished'">
            <h2>Quiz terminé</h2>
            <p v-if="quizData.windowQuitingCount > 2">Vous avez quitté le Quiz 3 fois, celui-ci a pris fin automatiquement.</p>
            <p v-else>Vous pouvez consulter vos résultats dans la liste de vos questionnaires terminés.</p>

            <div class="btn-wrapper">
                <div @click="goToLendingPage">Retour à la liste</div>
            </div>
        </div>

        <div class="answer-frame" v-else-if="quizData && quizData.status == 'in_progress'">
            <div class="question-box" v-for="(question, index) in answersList" :key="index">
                <h3>{{ index + 1 }} : {{ question.questionLabel }}</h3>

                <div class="options">
                    <div class="option" v-for="option in question.questionOptions" :key="option._id">
                        <input type="checkbox" v-model="option.selected">
                        <h4>{{ option.text }}</h4>
                    </div>
                </div>

                <div class="confidence-box">
                    <div :class="{ 'selected': question.confidenceLevel == 'high' }"
                        @click="question.confidenceLevel = 'high'">Très sûr</div>
                    <div :class="{ 'selected': question.confidenceLevel == 'medium' }"
                        @click="question.confidenceLevel = 'medium'">Moyennement sûr</div>
                    <div :class="{ 'selected': question.confidenceLevel == 'low' }"
                        @click="question.confidenceLevel = 'low'">Peu sûr</div>
                </div>
            </div>

            <div class="btn-wrapper">
                <div @click="endQuiz">Envoyer</div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            quizData: undefined,
            answersList: [],
            currentTime: new Date(),
            intervalTimer: null,
            tricheCount: 0,
        }
    },
    methods: {
        goToLendingPage() {
            this.$router.replace("/academy-learner");
        },
        async getEvaluationData() {
            const res = await axios.get(this.$store.getters.get_api_url + 'academy/find-evaluation/' + this.$route.params.quizId);
            this.quizData = res.data;
            this.answersList = res.data.answers.map(answer => {
                return {
                    ...answer,
                    questionOptions: answer.questionOptions.map(option => {
                        return {
                            ...option,
                            selected: answer.chosenOptions.includes(option._id)
                        }
                    }),
                }
            });
            
            this.tricheCount = res.data.windowQuitingCount;
        },
        async startQuiz() {
            const validation = confirm('Démarrer le quiz ?');
            if (!validation) return;

            await axios.post(this.$store.getters.get_api_url + 'academy/start-evaluation/' + this.$route.params.quizId);
            this.getEvaluationData();
        },
        async saveAnswers() {
            await axios.put(this.$store.getters.get_api_url + 'academy/save-answers/', {
                answers: this.answersList.map(a => {
                    return {
                        questionId: a.questionId,
                        chosenOptions: a.questionOptions.filter(option => option.selected).map(option => option._id),
                        confidenceLevel: a.confidenceLevel,
                    }
                }),
                quizId: this.$route.params.quizId,
            });
        },
        async endQuiz() {
            const validation = confirm('Valider vos réponses ?');
            if (!validation) return;

            await axios.put(this.$store.getters.get_api_url + 'academy/end-evaluation/', {
                answers: this.answersList.map(a => {
                    return {
                        questionId: a.questionId,
                        chosenOptions: a.questionOptions.filter(option => option.selected).map(option => option._id),
                        confidenceLevel: a.confidenceLevel,
                    }
                }),
                quizId: this.$route.params.quizId,
            });
            this.getEvaluationData();
        },
        async detectCheating() {
            if (this.quizData?.status !== 'in_progress') return;
            if (!this.quizData.beginingDate) return;
            if (!document.hidden && document.hasFocus()) return;

            this.tricheCount++;

            alert(`⚠️ Vous avez quitté l'écran. Cette action est enregistrée. Tentative ${this.tricheCount}/3`);

            const res = await axios.put(this.$store.getters.get_api_url + 'academy/increment-cheating', {
                quizId: this.quizData._id
            });

            if (res.data.endQuiz) {
                this.getEvaluationData(); // recharge pour afficher l'écran de fin
            }
        },
    },
    computed: {
        remainingTime() {
            if (!this.quizData?.beginingDate || !this.quizData?.nbMinutesDuration || this.quizData.status == 'finished') return null;

            const start = new Date(this.quizData.beginingDate);
            const end = new Date(start.getTime() + this.quizData.nbMinutesDuration * 60 * 1000);
            const diffMs = end - this.currentTime;

            if (diffMs <= 0) return { minutes: 0, seconds: 0 };

            const minutes = Math.floor(diffMs / 60000);
            const seconds = Math.floor((diffMs % 60000) / 1000);

            return { minutes, seconds };
        }
    },
    watch: {
        remainingTime(newVal) {
            if (newVal && newVal.minutes === 0 && newVal.seconds === 0) {
                this.endQuiz();
            }
        },
        answersList: {
            deep: true,
            handler() {
                this.saveAnswers();
            }
        }
    },
    mounted() {
        this.getEvaluationData();

        this.intervalTimer = setInterval(() => {
            this.currentTime = new Date();
        }, 1000);

        // Détecteurs d'evenement
        window.addEventListener('blur', this.detectCheating);
        document.addEventListener('visibilitychange', this.detectCheating);

    },
    beforeUnmount() {
        clearInterval(this.intervalTimer);

        window.removeEventListener('blur', this.detectCheating);
        document.removeEventListener('visibilitychange', this.detectCheating);
    },
}
</script>

<style scoped>
.evaluation-page {
    width: 800px;
    margin: 30px auto;
    position: relative;
}

.timer-frame {
    position: fixed;
    top: 100px;
    right: 20px;
    background-color: #FB984B;
    color: white;
    font-weight: bold;
    padding: 15px;
    border-radius: 10px;
}

.timer-frame p {
    text-align: center;
    margin: 0;
}

.message-frame {
    padding: 20px;
    border-radius: 20px;
    background-color: white;
}

.message-frame h2 {
    text-align: center;
    color: #0A1C6B;
}

ul {
    list-style: none;
    padding-left: 0;
}

ul.points-list li::before {
    content: "✅ ";
    margin-right: 0.5em;
}

ul.malus-list li::before {
    content: "❌ ";
    margin-right: 0.5em;
}

.btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
}

.btn-wrapper div {
    cursor: pointer;
    padding: 15px;
    background-color: #FB984B;
    color: white;
    font-weight: bold;
    border-radius: 10px;
}

/* Réponses au questionnaire */
.answer-frame {
    display: flex;
    flex-direction: column;
}

.question-box {
    margin: 5px;
    padding: 10px 15px;
    border-radius: 10px;
    background-color: white;
}

.options {
    display: flex;
    flex-direction: column;
}

.options .option {
    display: flex;
    align-items: center;
    padding: 5px;
}

.options .option h4 {
    padding: 0;
    margin: 0;
    font-weight: lighter;
    margin-left: 10px;
}

.confidence-box {
    width: 500px;
    margin: 10px auto 0 auto;
    display: flex;
    justify-content: center;
}

.confidence-box div {
    cursor: pointer;
    padding: 10px;
    text-align: center;
    flex-basis: 33%;
    background-color: #f8F4EB;
    font-size: 12px;
}

.confidence-box div:first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border-right: 1px solid white;
}

.confidence-box div:last-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-left: 1px solid white;
}

.confidence-box div.selected {
    background-color: #0A1C6B;
    color: white;
}
</style>